export default __webpack_public_path__ + "static/media/goodsound.94ec08ca.mp3";